<header id="main-header">
  <div class="header-container">
    <div class="right-section">
      <a routerLink="/" class="logo">
        <img [src]="staticImages.logo" alt="شیدا" width="130" />
      </a>
      <div class="menu-buttons">
        <app-button Link="/" Text="خانه" Icon="home" Appearance="default" [IsRouterActive]="true" />
        <app-button Link="/c/series" Text="سریال" Icon="videocam" Appearance="default" [IsRouterActive]="true" />
        <app-button Link="/c/movie" Text="فیلم" Icon="theaters" Appearance="default" [IsRouterActive]="true" />
        @if (userInfo()?.id) {
          <app-button
            Link="/watch-list"
            Text="لیست من"
            Icon="bookmarks"
            Appearance="default"
            [IsRouterActive]="true"
            [IsButton]="true"
          />
        }
      </div>
    </div>
    <div class="left-section">
      <div class="in-mobile">
        <app-icon-button [IsButton]="true" (Click)="showHamburgerMenu()" Icon="menu" Appearance="default" />
        @if (userInfo()) {
          @if (!userInfo()?.activeSubscription?.id) {
            <app-button
              [IsButton]="true"
              class="buy-plan-btn"
              (Click)="handleNavigatePlans()"
              Text="خرید اشتراک"
              Icon="shop"
            />
          }
        } @else {
          <app-button
            [IsButton]="true"
            class="buy-plan-btn"
            (Click)="handleNavigatePlans()"
            Text="خرید اشتراک"
            Icon="shop"
          />
        }
      </div>
      <div class="in-desktop">
        <div class="menu-box">
          @if (userInfo()) {
            <div class="dashed-profile">
              @if (remainingDays() !== undefined) {
                @if (remainingDays()! > 7) {
                  <div class="basic-ring"></div>
                } @else {
                  <app-dashed-ring [colors]="handleDashedColor" />
                }
              }
              @if (remainingDays() !== undefined && showRemainingTooltip()) {
                @if (remainingDays()! <= 7 && remainingDays()! > 0) {
                  <div [class]="['remaining-tooltip', 'remaining-day__' + remainingDays()]">
                    {{ remainingDays() }} روز تا پایان اشتراک
                  </div>
                } @else {
                  <div class="remaining-tooltip remaining-day__0">اشتراک ندارید</div>
                }
              }

              <button mat-icon-button [class]="{ 'menu-button': true }" [matMenuTriggerFor]="menu">
                <app-image-generator
                  [src]="userInfo()!.activeProfile.avatar"
                  [name]="userInfo()!.activeProfile.name"
                  imageType="square"
                />
              </button>
            </div>
            <mat-menu class="menu-box-items" #menu="matMenu" backdropClass="menu-box-items-backdrop">
              <ng-container *ngTemplateOutlet="loginUserInfo" />
            </mat-menu>
          } @else {
            <app-button class="login-btn" Link="/auth" Text="ورود/ثبت نام" Icon="person" Appearance="accent" />
            <app-button
              [IsButton]="true"
              class="buy-plan-btn"
              (Click)="handleNavigatePlans()"
              Text="خرید اشتراک"
              Icon="shop"
            />
            <app-icon-button class="login-icon-btn" Link="/auth" Icon="person" Appearance="default" />
          }
          <app-icon-button Link="/search" Icon="search" Appearance="default" />
        </div>
      </div>
    </div>
    <div class="category-items">
      <app-tag-button Link="/c/movie" Text="فیلم" />
      <app-tag-button Link="/c/series" Text="سریال" />
    </div>
  </div>
</header>

<ng-template #loginUserInfo>
  @if (userInfo()) {
    @if (remainingDays() !== 0) {
      <div
        [class]="[
          'remaining-subscription',
          'remaining-day__' + (remainingDays()! > 0 && remainingDays()! < 7 ? remainingDays() : ''),
        ]"
      >
        <b>{{ remainingDays() }} روز </b>
        <span> تا پایان اشتراک</span>
      </div>
    } @else if (generalService.freeIsp) {
      <div class="remaining-subscription">
        <span>اشتراک ویژه کاربران {{ generalService.freeIspName }}</span>
      </div>
    } @else {
      <div class="buy-subscription">
        <h4>شما اشتراک فعالی ندارید</h4>
        <app-button Icon="shop" Text="خرید اشتراک" [FullWidth]="true" Link="/account/plans" />
      </div>
    }

    @for (item of userInfo()?.otherProfiles; track item) {
      <button
        mat-flat-button
        [class]="{ 'profile-item': true, 'active-profile': item.id === userInfo()?.activeProfile?.id }"
        (click)="selectProfile(item)"
      >
        <span>{{ item.name }}</span>
        <div class="profile-image">
          <app-image-generator [src]="item.avatar" [name]="item.name" imageType="square" />
        </div>
      </button>
    }
    <mat-divider></mat-divider>
    <button mat-flat-button routerLink="/account/profiles" class="profile-item other-profile-item">
      <mat-icon>manage_accounts</mat-icon>
      <span>حساب کاربری</span>
    </button>
    <button mat-flat-button routerLink="/account/devices" class="profile-item other-profile-item">
      <mat-icon>devices</mat-icon>
      <span>مدیریت دستگاه‌ها</span>
    </button>
    <button mat-flat-button routerLink="/account/tv" class="profile-item other-profile-item">
      <mat-icon>tv</mat-icon>
      <span>ورود تلویزیون هوشمند</span>
    </button>
    <button mat-flat-button (click)="logout()" class="profile-item other-profile-item">
      <mat-icon>logout</mat-icon>
      <span>خروج از حساب</span>
    </button>
  }
</ng-template>
